import { useEffect, type ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
  actions: ReactNode;
  onClose: () => void;
}

export function Modal({ title, subtitle, children, actions, onClose }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="scrim"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal" role="dialog" aria-modal="true" aria-label={title}>
        <div className="modal__title">{title}</div>
        {subtitle && <div className="modal__sub">{subtitle}</div>}
        {children}
        <div className="acts">{actions}</div>
      </div>
    </div>
  );
}
